module.exports = __webpack_public_path__ + "static/assets/ce96797b9d9689af72adb0bdf0d0f094.svg";